var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AppHeader"},[(_vm.content)?_c('div',{staticClass:"titleBox"},[_c('el-page-header',{attrs:{"title":"返回","content":_vm.content},on:{"back":_vm.goBack}})],1):_c('div',{staticClass:"titleBox"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }